module.exports = __webpack_public_path__ + "img/benefit.773b48c3.png";